<template>
  <badiu-tiptap-file-upload
    :accept="accept"
    :filetype="filetype"
    :title="title"
    :icon="icon"
    :config="config"
    @uploaded="onUploaded"
    @error="onError"
  />
</template>

<script>
/**
 * BadiuTiptapImageUpload
 *
 * Specialised wrapper of BadiuTiptapFileUpload for images.
 * Keeps upload responsibility separate from the image modal component.
 */
import BadiuTiptapFileUpload from './BadiuTiptapFileUpload.vue'

export default {
  name: "BadiuTiptapImageUpload",

  components: {
    BadiuTiptapFileUpload
  },

  props: {
    accept: {
      type: String,
      default: "image/*"
    },

    filetype: {
      type: String,
      default: "image"
    },

    title: {
      type: String,
      default: "Upload image"
    },

    /** Font Awesome icon class forwarded to BadiuTiptapFileUpload. */
    icon: {
      type: String,
      default: "fa-upload"
    },

    /** Forwarded to BadiuTiptapFileUpload (ver BadiuTiptapEditor para doc das chaves). */
    config: {
      type: Object,
      default: () => ({})
    }
  },

  emits: ["uploaded", "error"],

  setup(_, { emit }) {
    function onUploaded(payload) {
      emit("uploaded", payload);
    }

    function onError(payload) {
      emit("error", payload);
    }

    return { onUploaded, onError };
  }
};
</script>
